<template>
  <div>
    <ToastContainer />
    <router-view class="font-old"/>
  </div>
  
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { useLanguageStore } from "@/stores/language";
import { useUserStore } from "@/stores/user"

import ToastContainer from "@/components/ToastContainer.vue"

@Options({
  components: {
    ToastContainer
  }
})
export default class App extends Vue {
  languageStore = useLanguageStore()
  userStore = useUserStore()

  mounted() {
    console.log("App Mounted")

    const root = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)
    root.classList.add('gradiant-background');

    document.body.style.background = "#00000000";
  }
}
</script>

<style lang="stylus">
html {
  position: absolute
  top: 0
  bottom: 0
  left: 0
  right: 0
}

body {
  position: absolute
  top: 0
  bottom: 0
  left: 0
  right: 0
}

#app {
  height: 100%
}

</style>